module.exports = __webpack_public_path__ + "static/media/Table.f2958d98.svg";